import { SvgIconProps } from "../types";
import "./style.css";

export const PngIcon = ({ src, width, height }: SvgIconProps) => (
  <div className = "img-container">
    <img src={`./img/png/${src}`} alt={src} width={width} height={height} />
  </div>
);
